module.exports = __webpack_public_path__ + "static/media/about-you-white.223a6676.svg";